function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { SELECT_EVENT_COLLECTION, SELECT_ANALYSIS, SELECT_TIMEZONE, SELECT_TARGET_PROPERTY, SET_QUERY, SET_PROPERTY_NAMES, SET_LIMIT, SET_EXTRACTION_LIMIT, SET_PERCENTILE, SET_TIMEFRAME, SET_GROUP_BY, SET_INTERVAL, SET_ORDER_BY, SET_FILTERS, DEFAULT_ANALYSIS, DEFAULT_TIMEFRAME, ADD_FUNNEL_STEP, SET_FUNNEL_STEPS, SET_FUNNEL_STEP_FILTERS, CLONE_FUNNEL_STEP, REMOVE_FUNNEL_STEP, UPDATE_FUNNEL_STEP, DEFAULT_FUNNEL_STEP, CHANGE_FUNNEL_STEPS_ORDER, ADD_FUNNEL_STEP_FILTER, UPDATE_FUNNEL_STEP_FILTER, REMOVE_FUNNEL_STEP_FILTER, UPDATE_FUNNEL_STEP_TIMEZONE, RESET_EXTRACTION, RESET_QUERY, ADD_FILTER, UPDATE_FILTER, REMOVE_FILTER, DEFAULT_FILTER, DEFAULT_EXTRACTION_LIMIT } from './constants';
import { inheritFromPreviousStep } from './utils';
export var initialState = {
  eventCollection: null,
  targetProperty: null,
  percentile: undefined,
  timezone: null,
  groupBy: undefined,
  orderBy: undefined,
  limit: undefined,
  interval: undefined,
  timeframe: DEFAULT_TIMEFRAME,
  analysisType: DEFAULT_ANALYSIS,
  steps: [],
  filters: [],
  propertyNames: undefined,
  latest: DEFAULT_EXTRACTION_LIMIT
};
export var queryReducer = function queryReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ADD_FILTER:
      return _objectSpread(_objectSpread({}, state), {}, {
        filters: [].concat(_toConsumableArray(state.filters), [_objectSpread(_objectSpread({}, DEFAULT_FILTER), {}, {
          id: action.payload.id
        })])
      });

    case REMOVE_FILTER:
      return _objectSpread(_objectSpread({}, state), {}, {
        filters: state.filters.filter(function (_filter) {
          return _filter.id !== action.payload.id;
        })
      });

    case UPDATE_FILTER:
      return _objectSpread(_objectSpread({}, state), {}, {
        filters: state.filters.map(function (filter) {
          if (filter.id === action.payload.id) {
            return _objectSpread(_objectSpread({}, filter), action.payload.filter);
          }

          return filter;
        })
      });

    case RESET_QUERY:
      return _objectSpread(_objectSpread({}, initialState), {}, {
        timezone: action.payload.defaultTimezoneForQuery
      });

    case RESET_EXTRACTION:
      return _objectSpread(_objectSpread({}, state), {}, {
        propertyNames: undefined,
        latest: DEFAULT_EXTRACTION_LIMIT
      });

    case SET_QUERY:
      return _objectSpread(_objectSpread({}, initialState), action.payload.query);

    case SET_LIMIT:
      return _objectSpread(_objectSpread({}, state), {}, {
        limit: action.payload.limit
      });

    case SET_INTERVAL:
      return _objectSpread(_objectSpread({}, state), {}, {
        interval: action.payload.interval
      });

    case SET_EXTRACTION_LIMIT:
      return _objectSpread(_objectSpread({}, state), {}, {
        latest: action.payload.limit
      });

    case SET_PROPERTY_NAMES:
      return _objectSpread(_objectSpread({}, state), {}, {
        propertyNames: action.payload.propertyNames
      });

    case SET_FILTERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        filters: action.payload.filters
      });

    case UPDATE_FUNNEL_STEP:
      return _objectSpread(_objectSpread({}, state), {}, {
        steps: state.steps.map(function (step) {
          if (step.id === action.payload.stepId) {
            return _objectSpread(_objectSpread({}, step), action.payload.properties);
          }

          return step;
        })
      });

    case REMOVE_FUNNEL_STEP:
      return _objectSpread(_objectSpread({}, state), {}, {
        steps: state.steps.filter(function (_step) {
          return _step.id !== action.payload.stepId;
        })
      });

    case ADD_FUNNEL_STEP:
      return _objectSpread(_objectSpread({}, state), {}, {
        steps: [].concat(_toConsumableArray(state.steps), [_objectSpread(_objectSpread(_objectSpread({}, DEFAULT_FUNNEL_STEP), {}, {
          timezone: action.payload.defaultTimezone
        }, inheritFromPreviousStep(state.steps)), {}, {
          id: action.payload.id
        })])
      });

    case CLONE_FUNNEL_STEP:
      return _objectSpread(_objectSpread({}, state), {}, {
        steps: [].concat(_toConsumableArray(state.steps), _toConsumableArray(state.steps.filter(function (step) {
          return step.id === action.payload.cloneId;
        }).map(function (step) {
          return _objectSpread(_objectSpread({}, step), {}, {
            id: action.payload.newId
          });
        })))
      });

    case CHANGE_FUNNEL_STEPS_ORDER:
      return _objectSpread(_objectSpread({}, state), {}, {
        steps: action.payload.steps.map(function (step, idx) {
          if (idx === 0) {
            return _objectSpread(_objectSpread({}, step), {}, {
              inverted: false,
              optional: false
            });
          }

          return step;
        })
      });

    case SET_FUNNEL_STEPS:
      return _objectSpread(_objectSpread({}, state), {}, {
        steps: action.payload.steps
      });

    case ADD_FUNNEL_STEP_FILTER:
      return _objectSpread(_objectSpread({}, state), {}, {
        steps: state.steps.map(function (step) {
          if (step.id === action.payload.stepId) {
            return _objectSpread(_objectSpread({}, step), {}, {
              filters: [].concat(_toConsumableArray(step.filters), [_objectSpread({
                id: action.payload.filterId
              }, DEFAULT_FILTER)])
            });
          }

          return step;
        })
      });

    case SET_FUNNEL_STEP_FILTERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        steps: state.steps.map(function (step) {
          if (step.id === action.payload.stepId) {
            return _objectSpread(_objectSpread({}, step), {}, {
              filters: action.payload.filters
            });
          }

          return step;
        })
      });

    case UPDATE_FUNNEL_STEP_FILTER:
      return _objectSpread(_objectSpread({}, state), {}, {
        steps: state.steps.map(function (step) {
          if (step.id === action.payload.stepId) {
            return _objectSpread(_objectSpread({}, step), {}, {
              filters: step.filters.map(function (filter) {
                if (filter.id === action.payload.filterId) {
                  return _objectSpread(_objectSpread({}, filter), action.payload.properties);
                }

                return filter;
              })
            });
          }

          return step;
        })
      });

    case REMOVE_FUNNEL_STEP_FILTER:
      return _objectSpread(_objectSpread({}, state), {}, {
        steps: state.steps.map(function (step) {
          if (step.id === action.payload.stepId) {
            return _objectSpread(_objectSpread({}, step), {}, {
              filters: step.filters.filter(function (filter) {
                return filter.id !== action.payload.filterId;
              })
            });
          }

          return step;
        })
      });

    case UPDATE_FUNNEL_STEP_TIMEZONE:
      return _objectSpread(_objectSpread({}, state), {}, {
        steps: state.steps.map(function (step) {
          if (step.id === action.payload.stepId) {
            return _objectSpread(_objectSpread({}, step), {}, {
              timezone: action.payload.timezone
            });
          }

          return step;
        })
      });

    case SET_ORDER_BY:
      return _objectSpread(_objectSpread({}, state), {}, {
        orderBy: action.payload.orderBy
      });

    case SET_GROUP_BY:
      return _objectSpread(_objectSpread({}, state), {}, {
        groupBy: action.payload.groupBy
      });

    case SET_TIMEFRAME:
      return _objectSpread(_objectSpread({}, state), {}, {
        timeframe: action.payload.timeframe
      });

    case SET_PERCENTILE:
      return _objectSpread(_objectSpread({}, state), {}, {
        percentile: action.payload.percentile
      });

    case SELECT_TIMEZONE:
      return _objectSpread(_objectSpread({}, state), {}, {
        timezone: action.payload.timezone
      });

    case SELECT_TARGET_PROPERTY:
      return _objectSpread(_objectSpread({}, state), {}, {
        targetProperty: action.payload.property
      });

    case SELECT_ANALYSIS:
      return _objectSpread(_objectSpread({}, state), {}, {
        analysisType: action.payload.analysis
      });

    case SELECT_EVENT_COLLECTION:
      return _objectSpread(_objectSpread({}, state), {}, {
        eventCollection: action.payload.name
      });

    default:
      return state;
  }
};